import { FC } from "react";

interface SideBarHeaderProps {
  title: string;
  icon: JSX.Element;
}

const SideBarHeader: FC<SideBarHeaderProps> = ({ icon, title }) => {
  return (
    <div className="flex flex-col gap-1 justify-center items-center">
      {icon}
      <h4 className="text-salon-secondary text-xl">{title}</h4>
    </div>
  );
};

export default SideBarHeader;
